import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { catchError, tap, shareReplay } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpDataService {

  constructor(private http_: HttpClient) { }

  getBackendDatausehttpget(url:string) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options = { headers }
    return this.http_.get(url, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  getBackendDatausehttpgetparamsWithObj<T>(url:string,params:any,header?:{}): Observable<T | Observable<never>> {
    //console.log("getBackendDatausehttpgetparams=-===")
    let headers;
    if (header) {
      headers = { ...header, 'Content-Type': 'application/json' }
    }
    // const headers = new HttpHeaders({ Authorization: 'Basic ' + btoa(username + ':' + password) });
    else {
      headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
    }
    const options = { headers:headers , params };
      return this.http_.get<T>(url,options)
        .pipe(
          shareReplay(1),
          catchError(this.handleError)
        );
}

  getBackendDatausehttpgetparams<T>(url:string,params:any): Observable<T[] | Observable<never>> {
    //console.log("getBackendDatausehttpgetparams=-===")
    let headers1 = new HttpHeaders();
    headers1  = headers1.append('Content-Type','application/json')
    const options = { headers:headers1 , params };
      return this.http_.get<T[]>(url,options)
        .pipe(
          shareReplay(1),
          catchError(this.handleError)
        );
}
getBackendDatausehttppost<T>(filterData:any, url:string): Observable<T | Observable<never>> {
  let headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });
  let options = {
    headers
  }
  return this.http_.post<T>(url, filterData, options)
    .pipe(
      catchError(this.handleError)
    );
}
getBackendDatausehttpput<T>(filterData:any, url:string): Observable<T | Observable<never>> {
  let headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });
  let options = {
    headers
  }
  return this.http_.put<T>(url, filterData, options)
    .pipe(
      catchError(this.handleError)
    );
}
  getBackendDatausehttppostparams<T>(filterData:{},url:string,params:{}): Observable<T | Observable<never>> {
  let headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });
  let options = {
    headers,
    params
  }
  return this.http_.post<T>(url, filterData, options)
    .pipe(
      shareReplay(1),
      catchError(this.handleError)
    );

}

  handleError(error:any) {
    let errorMessage = '';
    if (error['error'] instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
